import React from 'react';
import withRouter from 'with-router'
import withStyles from '../../withStylesAdapter';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getTranslationProgress } from '../../modules/stats'
import { getShopGroupsWithSections } from '../../config/translatableResourceSections'
import classNames from 'classnames';
import {Radar, PieChart, Pie, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, BarChart, Bar, Label, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Trans, withTranslation, useTranslation } from 'react-i18next';

const data02 = [
  {
    "name": "Translated Fields",
    "value": 21400
  },
  {
    //"name": "Untranslated Fields",
    //"value": 4567
  },
];

// the Shop bar broken down the way the Shop page itself is laid out: the sections of the
// unlabelled group one by one, the labelled group as a single line under its heading. Shares that
// grouping with the page, so the two cannot drift apart
const shopTooltipParts = (countsByType, t) => {
  const countsOf = (sections) => sections.reduce((sum, section) =>
    section.resourceTypes.reduce((acc, type) => ({
      translatables: acc.translatables + (countsByType[type] ? countsByType[type].translatables : 0),
      translateds: acc.translateds + (countsByType[type] ? countsByType[type].translateds : 0),
    }), sum), { translatables: 0, translateds: 0 });

  // null where nothing has been counted yet, so it shows as a dash instead of a made up 0
  const share = (counts) => counts.translatables > 0
    ? Math.round(counts.translateds / counts.translatables * 10000) / 100
    : null;

  return getShopGroupsWithSections().flatMap(group => group.label
    ? [{ name: t(`pages.shop.groups.${group.label}`), value: share(countsOf(group.sections)) }]
    : group.sections.map(section => ({
        name: t(`pages.shop.sections.${section.key}`),
        value: share(countsOf([section])),
      })));
};

class TranslationProgressSection extends React.Component {

  pendingLock = false;
  
  constructor(props) {
    super(props);
    
    this.state = {
      progressData: [],
      progressMenuAnchor: null,
      showProgressMenu: false,
      currentLanguage: props.editLanguage,
    };
  }

  componentDidMount() {
    this.props.getTranslationProgress(this.props.editLanguage, this.props.editTheme);
    this.setProgressFilter(this.props.editLanguage, this.props.editTheme);
  }

  componentWillReceiveProps(newProps) {
    const currentLanguage = this.props.editLanguage;
    const newLanguage = newProps.editLanguage;
    const {t} = this.props;
    if(currentLanguage != newLanguage) {
      this.setState({
        currentLanguage: newLanguage
      });
      this.props.getTranslationProgress(newLanguage, this.props.editTheme)
      return
    }

    // If the current language was deleted, fall back to the first available language
    if (newProps.languages && newProps.languages.languages && !newProps.languages.languages.find(x => x.id == this.state.currentLanguage)) {
      const fallback = newProps.languages.languages.find(x => !x.base);
      if (fallback) {
        this.setProgressFilter(fallback.id, this.props.editTheme);
        return
      }
    }

    const currentTheme = this.props.editTheme;
    const newTheme = newProps.editTheme;
    if(currentTheme != newTheme) {
      this.props.getTranslationProgress(newLanguage, newTheme)
      return
    }

    if((this.props.stats.get_translation_progresses_pending === true && newProps.stats.get_translation_progresses_pending === false)) {
      this.pendingLock = true;
      const newProgressData = [];
      for(let i = 0; i < newProps.stats.translation_progresses.length; i++) {
        const item = newProps.stats.translation_progresses[i];
        if(item.type !== 'products' && item.type !== 'collections' && item.type !== 'blogs' && item.type !== 'articles') {
          newProgressData.push({
            name: t(`progressTile.${item.label.toLowerCase()}`),
            a: {
              name: item.label,
              value: item.progress ? item.progress : 0,
            },
            total: item.progress ? item.progress : 0,
            parts: item.counts_by_type ? shopTooltipParts(item.counts_by_type, t) : null,
          })
        } else {
          if(item.type === 'products' || item.type === 'blogs') {
            let totalValue = (item.progress ? item.progress : 0) + (newProps.stats.translation_progresses[i+1].progress ? newProps.stats.translation_progresses[i+1].progress : 0);
            newProgressData.push({
              name: item.type === 'products' ? t('progressTile.inventory') : t(`progressTile.${item.label.toLowerCase()}`),
              a: {
                name: item.label,
                value: item.progress ? item.progress / 2 : 0,
              },
              b: {
                name: newProps.stats.translation_progresses[i+1].label,
                value: newProps.stats.translation_progresses[i+1].progress ? newProps.stats.translation_progresses[i+1].progress / 2 : 0,
              },
              total: Math.round((totalValue / 2) * 100) / 100,
            });
          }
        }
      }

      this.setState({
        progressData: newProgressData
      });

      this.pendingLock = false;
    }
  }

  setProgressFilter = (languageId, themeId) => {
    this.props.getTranslationProgress(languageId, themeId);
    this.setState({
      showProgressMenu: false, 
      currentLanguage: languageId
    });
  }

  openProgressMenu = (e) => {
    this.setState({
      progressMenuAnchor:e.target,
      showProgressMenu: true
    });
  }

  closeProgressMenu = () => {
    this.setState({showProgressMenu: false});
  }

  renderCustomizedTooltip = ({ active, payload, label }) => {
    if(payload.length > 0) {
      return (
        <div className="custom-tooltip">
          <p className="label">
            {`${label}: ${!payload[0].payload.b ? payload[0].payload.a.value : Math.round((payload[0].payload.a.value + payload[0].payload.b.value) * 100) / 100}%`}
          </p>
          {payload[0].payload.b &&
            <div>
              <small className="subfield a">{payload[0].payload.a.name}: {payload[0].payload.a.value * 2}%</small>
              <small className="subfield b">{payload[0].payload.b.name}: {payload[0].payload.b.value * 2}%</small>
            </div>
          }
          {payload[0].payload.parts &&
            <div>
              {payload[0].payload.parts.map((part, i) =>
                <small key={`tooltip-part-${i}`} className="subfield">
                  {part.name}: {part.value === null ? '–' : `${part.value}%`}
                </small>
              )}
            </div>
          }
        </div>
      );      
    }
    return null;
  };

  renderSelect = () => {
    const usedLabel = (this.props.languages.languages.find(x => x.id == this.state.currentLanguage) || {}).name;
    return <React.Fragment>
      <span onClick={(e) => {this.openProgressMenu(e)}} style={{cursor:'pointer',float:'right',fontSize: 16}}><span style={{position:'relative',left:'4px'}}>{usedLabel}</span> <ExpandMoreIcon/></span>
      <Menu
        MenuListProps={{ dense: true }}
        onClose={this.closeProgressMenu}
        anchorEl={this.state.progressMenuAnchor}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={this.state.showProgressMenu}
      >
        {
          this.props.languages.languages.map((item, i) => {
            if(!item.base) {
              //console.log(this.state.currentLanguage, item.id)
              return <MenuItem key={`language-item-${i}`} selected={this.state.currentLanguage === item.id} value={item.id} onClick={() => {this.setProgressFilter(item.id, this.props.editTheme)}}>{item.name}</MenuItem>
            }
          })
        }
      </Menu>
    </React.Fragment>
  }

  render() {
    const { t, classes, theme } = this.props;
    const barColor = theme.palette.accentMuted;
    // only the open right end is rounded: the left end sits on the axis, a full bar on the chart's edge
    const endRadius = (row) => (row.total >= 100 ? 0 : [0, 4, 4, 0]);

    if(this.props.stats.get_translation_progresses_pending && !this.pendingLock) {
      return (
        <div variant="body1" className={classNames(classes.contentContainer)}>
            <Card className={classes.card}>
              <CardContent className={classNames(classes.cardContent, classes.fluidContent)} style={{height: '313px'}}>
                <Typography variant="subtitle1" style={{margin: '0 16px 0 24px', position: 'relative', top: 9, paddingTop: 7, paddingBottom: 7}}>
                  {t('progressTile.title')}
                  { this.renderSelect() }
                </Typography>
                <Divider style={{marginTop: 16, marginBottom: 0}} />

                <CircularProgress color="primary" size={60} style={{margin: 'auto'}} thickness={2}/>
              </CardContent>
            </Card>
        </div>
      );
    } else {
      return (
        <div variant="body1" className={classNames(classes.contentContainer)}>
            <Card className={classes.card}>
              <CardContent className={classNames(classes.cardContent, classes.fluidContent)} style={{height: '313px'}}>
                <Typography variant="subtitle1" style={{margin: '0 16px 0 24px', position: 'relative', top: 9, paddingTop: 7, paddingBottom: 7}}>
                {t('progressTile.title')}
                  { this.renderSelect() }
                </Typography>
                <Divider style={{marginTop: 16, marginBottom: 0}} />
                <ResponsiveContainer height={250}>

                  <BarChart 
                    className={this.props.classes.radarChart} 
                    data={this.state.progressData} 
                    layout="vertical" 
                    margin={{left: 24}}
                    maxBarSize={100}
                  >
                    <CartesianGrid 
                      stroke={theme.palette.divider} 
                      strokeDasharray="4" 
                      layout="vertical" 
                    />
                    {/*
                      cursor explizit setzen: recharts zeichnet die Hover-Fläche
                      hinter dem aktiven Balken sonst mit seinem Default
                      fill: '#ccc' (getCursorRectangle.js), das auf der dunklen
                      Karte hell aufleuchtet.
                    */}
                    <Tooltip
                      content={this.renderCustomizedTooltip}
                      cursor={{ fill: theme.palette.action.hover }}
                      arrow
                    />
                    {/* the percentage shows in the hover tooltip only; no bar animation, a running bulk
                        task refetches the progress and a re-animating chart flickers */}
                    <Bar 
                      dataKey={val => val.a.value}
                      stackId="a"
                      fill={barColor}
                      barSize={14} 
                      maxBarSize={100}
                      isAnimationActive={false}
                    >
                      {this.state.progressData.map((row, i) => (
                        <Cell key={i} radius={row.b && row.b.value > 0 ? 0 : endRadius(row)} />
                      ))}
                    </Bar>
                    <Bar 
                      dataKey={val => val.b ? val.b.value : 0}
                      stackId="a"
                      fill={alpha(barColor, 0.55)}
                      barSize={14} 
                      maxBarSize={100}
                      isAnimationActive={false}
                    >
                      {this.state.progressData.map((row, i) => (
                        <Cell key={i} radius={endRadius(row)} />
                      ))}
                    </Bar>
                    <XAxis type="number" dataKey="total" padding={{bottom: 0}} domain={[0, 100]} hide />
                    <YAxis type="category" dataKey="name" interval={0} />
                  </BarChart>    

                </ResponsiveContainer>
              </CardContent>
            </Card>
        </div>
      )
    }
  }
}

const styles = (theme, state) => ({
  contentContainer: {
    marginBottom: theme.spacing(3),
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    background: theme.palette.mode === 'dark'
      ? 'linear-gradient(360deg, rgba(30,30,30,1) 0%, rgba(38,38,38,1) 100%)'
      : 'linear-gradient(360deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.9) 100%)',
    position: 'relative',
    padding: '16px !important',
    [theme.breakpoints.down('md')]: {
      minHeight: 0,
    }
  },
  fluidContent: {
    padding: '0 !important',
    [theme.breakpoints.down('sm')]: {
      height: 'auto !important',
      minHeight: 250,
    },
  },
  radarChart: {
    padding: '10px',
    '& text': {
      fontSize: 13,
    },
    '& .recharts-cartesian-axis-tick-value': {
      fontSize: 13,
      fill: theme.palette.text.primary,
    },
    '& .recharts-surface': {
      height: '230px !important',
      overflow: 'initial'
    }
  },
});


const mapStateToProps = ({shop, languages, themes, stats}) => ({
  stats: stats,
  languages: languages,
  editTheme: themes.edit_theme,
  editLanguage: shop.shop.edit_language,
  shopUrl: shop.shop.url,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getTranslationProgress
    },
    dispatch
  )
  
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(TranslationProgressSection))))
